import { render, staticRenderFns } from "./NwFormBp.vue?vue&type=template&id=c2e7e520&scoped=true&"
import script from "./NwFormBp.vue?vue&type=script&lang=js&"
export * from "./NwFormBp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e7e520",
  null
  
)

export default component.exports